/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/tile/custom-elements';

import { defineCustomElement as defineOsdsTile } from '@ovhcloud/ods-stencil/components/tile/custom-elements/osds-tile.js';

export const OsdsTile = /*@__PURE__*/createReactComponent<JSX.OsdsTile, HTMLOsdsTileElement>('osds-tile', undefined, undefined, defineOsdsTile);
